import React from 'react';
import { ButtonProps } from 'antd/lib/button';

import { CmonJobInstanceCommand } from '../../../services/cmon/models/CmonJobInstance';
import CcNode from '../../../services/models/CcNode';
import NodeStopForm from './NodeStopForm';
import ButtonWithForm from '../../../common/General/ButtonWithForm';
import JobActionButton from '../../Jobs/JobActionButton';

export default NodeStopButton;

export type NodeStopButtonProps = ButtonProps & {
    node: CcNode;
    children?: React.ReactNode;
    onSuccess?: () => void;
};

function NodeStopButton({
    node,
    children,
    onSuccess,
    ...rest
}: NodeStopButtonProps) {
    return (
        <ButtonWithForm
            button={
                <JobActionButton
                    command={CmonJobInstanceCommand.STOP}
                    clusterId={node.clusterid}
                    critical={true}
                    extraKey={[node.hostname, node.port]}
                    {...rest}
                >
                    {children || 'Stop node'}
                </JobActionButton>
            }
            form={<NodeStopForm node={node} onSuccess={onSuccess} />}
        />
    );
}
